module.exports = __webpack_public_path__ + "images/nosotros1.819edf92dfa4f745604104be2066278e.jpeg";